import { yupResolver } from "@hookform/resolvers/yup";
import InfoIcon from "@mui/icons-material/Info";
import { Button, Chip, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import ControlledTextFieldSeparatedLabel from "../../../../components/controlled/ControlledTextFieldSeparatedLabel/index.jsx";
import { useUpdateTransporeonIntegrationMutation } from "../../integrationsApiSlice.js";
import { getFormSchema } from "./formSchema.js";

export const TransporeonForm = ({
	status,
	transporeonEmail,
	transporeonCompany,
}) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [updateTransporeonIntegration, { isLoading }] =
		useUpdateTransporeonIntegrationMutation();

	const formSchema = getFormSchema(t);
	const {
		handleSubmit,
		control,
		formState: { errors },
		setValue,
		setError,
	} = useForm({
		defaultValues: {
			transporeonEmail,
			transporeonCompany,
		},
		resolver: yupResolver(formSchema),
		shouldFocusError: true,
	});

	useEffect(() => {
		if (transporeonEmail) {
			setTimeout(() => {
				setValue("transporeonEmail", transporeonEmail);
			}, 200);
		}
		if (transporeonCompany) {
			setTimeout(() => {
				setValue("transporeonCompany", transporeonCompany);
			}, 200);
		}
	}, [transporeonEmail, transporeonCompany, setValue]);

	useEffect(() => {
		if (Object.keys(errors).length > 0) {
			Object.values(errors).forEach((err) => {
				if (err.message) {
					enqueueSnackbar(err.message, {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
		}
	}, [errors, enqueueSnackbar]);

	const onSubmit = async ({ transporeonEmail, transporeonCompany }) => {
		await updateTransporeonIntegration({
			transporeonEmail,
			transporeonCompany,
		})
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("updated_transporeon_integration"), {
					variant: "success",
				});
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([key, message]) => {
						setError(key);
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return (
		<>
			<Box
				component="form"
				autoComplete="off"
				noValidate
				onSubmit={handleSubmit(onSubmit)}
				sx={{ p: 0 }}
			>
				<Box
					sx={{
						mb: 1,
						display: "flex",
						alignItems: "center",
						gap: "6px",
					}}
				>
					<Typography sx={{ fontWeight: 600 }}>{t("status")}: </Typography>
					{status ? (
						<Chip label={t("integrated")} color="success" />
					) : (
						<Chip label={t("no_integration")} color="secondary" />
					)}
				</Box>
				<input type="text" style={{ display: "none" }} />
				<input type="password" style={{ display: "none" }} />
				<Grid container spacing={5}>
					<Grid size={6}>
						<Grid container spacing={2}>
							<Grid size={12}>
								<ControlledTextFieldSeparatedLabel
									control={control}
									name="transporeonEmail"
									type="text"
									label="Transporeon Email"
									error={!!errors?.transporeonEmail}
									labelXs={6}
									fieldXs={6}
									autoComplete="off transporeonEmail new-password"
									inputProps={{
										autoComplete: "off transporeonEmail new-password",
									}}
								/>
							</Grid>
							<Grid size={12}>
								<ControlledTextFieldSeparatedLabel
									control={control}
									name="transporeonCompany"
									type="text"
									label="Transporeon Company"
									error={!!errors?.transporeonCompany}
									labelXs={6}
									fieldXs={6}
									autoComplete="off transporeonCompany new-password"
									inputProps={{
										autoComplete: "off transporeonCompany new-password",
									}}
								/>
							</Grid>
							<Grid size={12}>
								<Box sx={{ display: "flex", justifyContent: "end" }}>
									<Button loading={isLoading} type="submit" variant="contained">
										{t("save")}
									</Button>
								</Box>
							</Grid>
						</Grid>
					</Grid>
					<Grid size={6}>
						{/* <Box
						sx={{
							border: "2px solid #ffc000",
							background: "#ffffd9",
							padding: "14px",
							maxWidth: "500px",
						}}
					>
						<Typography>
							{t("tele_integration_info_1")}
							<br />
							{t("tele_integration_info_2")}
						</Typography>
					</Box> */}
					</Grid>
				</Grid>
			</Box>
			<Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: "8px" }}>
				<InfoIcon color="info" />
				<Typography variant="body2">
					<Trans
						i18nKey="transporeon_stocks_info"
						components={{
							1: (
								<a
									href="https://docs.google.com/forms/d/1TaRb0iBAmF9iepDxr7Rtn9oXIi3NSH_9rWEzPbJKEr8/viewform?edit_requested=true#responses"
									target="_blank"
									rel="noreferrer"
									style={{
										color: "#1976d2",
										textDecoration: "underline",
										fontWeight: "600",
										fontSize: "15px",
									}}
								>
									TUTAJ
								</a>
							),
						}}
					/>
				</Typography>
			</Box>
		</>
	);
};
